import { useEffect, useState } from 'react'
import { useNavigate, useRoutes } from 'react-router-dom'
import router from '../../router'

import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'

import { CssBaseline } from '@mui/material'
import ThemeProvider from '../../styles/theme/ThemeProvider'
import noInternetGif from '../../assets/images/nointernet.gif'
import ServerErrorGif from '../../assets/images/servererror.gif'
import Toaster from '../../shared/components/toaster/Toaster'
import { setNavigateCallback } from '../../shared/utilities/navigate'
import ErrorBoundary from '../../shared/components/ErrorBoundary'
import SuspenseLoader from '../../shared/components/SuspenseLoader'
import { bootstrapSession } from '../../logic/apis'
import { useAppDispatch } from '../../store/hooks'
import { hasValidAccessToken } from '../../logic/apis/auth'
import { restoreSession } from '../../store/slices/authSlice'

function App() {
  const navigate = useNavigate()
  setNavigateCallback(navigate)
  const dispatch = useAppDispatch()

  // Gate the router on the silent bootstrap. On first paint the in-memory
  // access token is empty; if an httpOnly refresh cookie is present we
  // exchange it before rendering the authed routes so AuthRedirect1 doesn't
  // bounce the admin back to /login. The promise resolves to false quickly
  // for unauthed visitors (no prior-session signal → no network call).
  const [bootstrapDone, setBootstrapDone] = useState(false)

  useEffect(() => {
    let cancelled = false
    bootstrapSession().then((restored) => {
      if (cancelled) return
      if (restored && hasValidAccessToken()) {
        // Flip the Redux isAuthenticated flag so any selector that relies on
        // it (sidebar items, header avatar, etc.) sees the restored session.
        dispatch(restoreSession())
      }
      setBootstrapDone(true)
    })
    return () => {
      cancelled = true
    }
  }, [dispatch])

  const content = useRoutes(router)
  return (
    <ThemeProvider>
      <ErrorBoundary>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Toaster />
          <CssBaseline />
          <img src={ServerErrorGif} alt="No internet" style={{ display: 'none' }} />
          <img src={noInternetGif} alt="No internet" style={{ display: 'none' }} />
          {bootstrapDone ? content : <SuspenseLoader left="10%" />}
        </LocalizationProvider>
      </ErrorBoundary>
    </ThemeProvider>
  )
}
export default App
